import { ViewType } from '@cycle-app/graphql-codegen';

import { make } from 'src/utils/reactives.util';

interface BoardConfigModalState {
  visible: boolean;
  disabled: boolean;
}

export const {
  hookValue: useGetBoardConfigModal,
  setValue: setBoardConfigModal,
} = make<BoardConfigModalState>({
  defaultState: {
    visible: false,
    disabled: false,
  },
});

/** viewType of the current view */
export const {
  hookValue: useViewType,
  setValue: setViewType,
} = make({
  defaultState: {
    viewType: ViewType.List,
  },
});
